angular.module('leanlaw').directive('llInvoiceStagingFilter', ['userService', function (userService) {
  return {
    restrict: 'EA',
    template: require('../views/stagingFilter.html'),
    scope: {
      state: '='
    },
    controller: ['$scope', async $scope => {
      $scope.me = await userService.me();
    }]
  };
}]);